import isStrictComparable from './_isStrictComparable';
import toPairs from './toPairs';

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = toPairs(object),
      length = result.length;

  while (length--) {
    result[length][2] = isStrictComparable(result[length][1]);
  }
  return result;
}

export default getMatchData;



//////////////////
// WEBPACK FOOTER
// ../ckeditor5-utils/src/lib/lodash/_getMatchData.js
// module id = 375
// module chunks = 0